/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, BackTop, Modal, Carousel, Select, Typography } from 'antd';
// import { FormattedMessage } from 'react-intl';
// import 'antd/dist/antd.css';
// import hospital from '../../Images/Hospital.png';
import qR2 from '../../Images/Qr.png';
import './style.css';
import Responsive from './Responsive';
import { selectDepartment, selectHospital, selectLocation, selectPromotions } from './Selectors';
import { ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import { fetchDepartmentList, fetchHospitalList, fetchLocationList, fetchPromotionsList } from './Actions';
import { useNavigate } from 'react-router-dom';
import noImage from '../../Images/planmysurgerybg.jpg';
import {InstagramOutlined, PlayCircleOutlined, YoutubeOutlined} from '@ant-design/icons';
import throttle from 'lodash.throttle';


// const InputGroup = Input.Group;

const TestimonialRepeat = ({ testimonials, byName, windowsize }) => {
    
    return (
        <Col span={24} style={{ marginBottom: '30px' }}>
            <div style={{ fontSize: windowsize - 3 <= 7 ? '10px' : '20px', color: '#fff', marginTop: '60px' }}>
                {`"${testimonials}"`}
            </div>
            <div style={{ fontSize: windowsize -3 <= 7 ? '10px' : '20px', color: '#fff', marginTop: '20px', textAlign: 'right' }}>{byName}</div>
        </Col>
    );
};

const Home = () => {
    const [locationState, setLocationState] = useState('');
    const [hospitalState, setHospitalState] = useState('');
    const [departmentsCheck, setDepartmentsCheck] = useState('');
    const [playingIndex, setPlayingIndex] = useState(null);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;    

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const departments = useSelector(selectDepartment);
    const locations = useSelector(selectLocation);
    const hospital = useSelector(selectHospital);
    const promotions = useSelector(selectPromotions);
    const [isHovered, setIsHovered] = useState(false);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalVideoUrl, setModalVideoUrl] = useState('');

    const containerRef = useRef();

    const promos = [];
    
    promotions && promotions.data && promotions.data.map((item)=>{
        promos.push({
            url:item.url ? item.url : null,
            thumbnail:item.thumbnail ? item.thumbnail : null,
            socialmediapromotionstype:item.socialmediapromotionstype && item.socialmediapromotionstype && item.socialmediapromotionstype.name ? item.socialmediapromotionstype.name.toLowerCase() : null,
            title:item.title
        });
    });

    const [viewportWidth, setViewportWidth] = useState(0);
    
    // Throttle the resize event and set the viewport width
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, 250),
        [250]
    );

    useEffect(() => {
        saveViewportDimensions();
        window.addEventListener('resize', saveViewportDimensions);

        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [saveViewportDimensions]);

    useEffect(() => {
        dispatch(fetchPromotionsList());
        const handleClickOutside = (e) => {
            if (
                containerRef.current &&
            !containerRef.current.contains(e.target)
            ) {
                setPlayingIndex(null); // Resume marquee
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
      
    const handleDepartmentChange = (value) => {
        
        if (!value) {
            setDepartmentsCheck('');
        } else {
            setDepartmentsCheck(value);
        }
    };
    
    const handleLocationChange = (value) => {
        if (!value) {
            setLocationState('');
        } else {
            setLocationState(value);
        }
    };

    const selectedHospital = (value) => {
        setHospitalState(value);
    };

    const handleHospitalChange = (value) => {
        if (!value) {
            setHospitalState('');
        } else if (!value.match(/\s/)) {
            setHospitalState('');
        }
    };


    const handleLocationFocus = () => {
        dispatch(fetchLocationList(null));
    };

    const handleHospitalFocus = () => {
        dispatch(fetchHospitalList(null));
    };

    const handleDepartmentSearch = (value) => {        
        if (!value) {
            dispatch(fetchDepartmentList(null));
        } else if (value.length >= 1) {
            dispatch(fetchDepartmentList(value));
        }
    };

    const handleLocationSearch = (value) => {
        if (!value) {
            dispatch(fetchLocationList(null));
        } else if (value.length >= 1) {
            dispatch(fetchLocationList(value));        }
    };

    const handleHospitalSearch = (value) => {
        if (!value) {
            dispatch(fetchHospitalList(null));
        } else if (value.length >= 1 && hospital !== undefined) {
            dispatch(fetchHospitalList(value));

        }
    };

    const search = () => {
        if (locationState !== '' || hospitalState !== '' || departmentsCheck !== '') {
            navigate(('/online-doctors-consultation'),{state : {locationState : locationState, hospitalState : hospitalState, departmentsState : departmentsCheck}});
        } else {
            Modal.warning({
                title: 'Select at least one value to search doctor',
            });
        }
    };

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleDepartmentFocus = () => {        
        dispatch(fetchDepartmentList(null));
    };

    const departmentChildren = [];
    const locationChildren = [];
    const hospitalChildren = [];

    if(departments) {
        departments && departments.map((item) => {
            departmentChildren.push({
                value : item.id,
                label : item.specialization
            });
        });
    }
    
    if(locations) {
        locations && locations.map((item) => {
            locationChildren.push({
                value : item.locality,
                label : item.locality
            });
        });
    }

    if(hospital) {
        hospital && hospital.map((item) => {
            hospitalChildren.push({
                value : item.name,
                label : item.name
            });
        });
    }

    const getEmbedUrl = (platform,url) => {
        
        try {
            const parsedUrl = new URL(url);
    
            if (platform === 'youtube') {
                const videoId = parsedUrl.pathname.includes('/shorts')
                    ? parsedUrl.pathname.split('/shorts/')[1]
                    : parsedUrl.pathname.split('/embed/')[1];
                return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            } 
          
            if (platform === 'instagram') {
                const pathParts = parsedUrl.pathname.split('/');
                const type = pathParts.includes('reel') ? 'reel' : 'p';
                return `https://www.instagram.com/${type}/${pathParts[2]}/embed`;
            }
    
            return '';
        } catch (error) {
            console.error('Invalid URL');
            return '';
        }
    };

    const handleVideoClick = (index, item) => {
        if (item.socialmediapromotionstype === 'instagram') {
            setModalVideoUrl(getEmbedUrl(item.socialmediapromotionstype, item.url));
            setIsModalVisible(true);
        } 
        setPlayingIndex(index);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setModalVideoUrl('');
    };
    
    return (
        <div>
            <div className="responsive" style={{paddingBottom:'5%'}}>
                <BackTop />
                <div>
                    <Row type="flex" justify="center">
                        {/* <Col className="searchTab" xxl={{ span: 14, offset: 1 }} xl={{ span: 14, offset: 1 }} md={{ span: 14, offset: 1 }} lg={{ span: 13, offset: 1 }} 

                        > */}
                        {/* <InputGroup compact style={{ display: 'flex' }}> */}
                        <Col className="searchTab" span={24}>
                            <Row>
                                <Col span={3}>&nbsp;</Col>
                                <Col span={6} style={{ margin: '5px', position : 'relative', zIndex : 2,  display:'flex', justifyContent:'right'  }}>
                                    <Select
                                        name="department"
                                        style={{
                                            width: '100%',
                                        }}
                                        size="large"
                                        onSearch={handleDepartmentSearch}
                                        onChange={handleDepartmentChange}
                                        onFocus={handleDepartmentFocus}
                                        placeholder={`${langdata.department ? langdata.department : 'Department' }`}
                                        // placeholder={<FormattedMessage {...messages.department} />}
                                        allowClear={true}
                                        showSearch
                                        options={departmentChildren}
                                        filterOption={filterOption}
                                    >
                                    </Select>
                                </Col>
                                <Col span={6} style={{ margin: '5px', position : 'relative', zIndex : 2,  display:'flex', justifyContent:'center'  }}>
                                    <Select
                                        name="location"
                                        style={{
                                            width: '100%',
                                        }} size="large"
                                        onFocus={handleLocationFocus}
                                        onSearch={handleLocationSearch}
                                        onChange={handleLocationChange}
                                        placeholder={`${langdata.location ? langdata.location : 'Location' }`}
                                        // placeholder={<FormattedMessage {...messages.location} />}
                                        allowClear={true}
                                        showSearch
                                        options={locationChildren}
                                        filterOption={filterOption}
                                    >
                                    </Select>
                                </Col>
                                <Col span={6} style={{ margin: '5px', position : 'relative', zIndex : 2,  display:'flex', justifyContent:'left'  }}>
                                    <Select
                                        name="hospital"
                                        style={{
                                            width: '100%',
                                        }} size="large"
                                        onFocus={handleHospitalFocus}
                                        onSearch={handleHospitalSearch}
                                        onSelect={selectedHospital}
                                        onChange={handleHospitalChange}
                                        placeholder={`${langdata.hospitals ? langdata.hospitals : 'Hospitals' }`}
                                        // placeholder={<FormattedMessage {...messages.hospitals} />}
                                        allowClear={true}
                                        showSearch
                                        options={hospitalChildren}
                                        filterOption={filterOption}
                                    >
                                    </Select>
                                </Col>
                                <Col span={3}>&nbsp;</Col>

                            </Row>
                        </Col>
                    
                        {/* </InputGroup> */}
                        {/* </Col> */}
                        {/* <Col xxl={{ span: 24, offset: 0 }} xl={{ span: 24, offset: 0 }} md={{ span: 24 }} xs={{ span: 14 }} style={{position : 'relative', zIndex : 2}}> */}
                        <Col span={24} style={{ marginTop: '1%', position : 'relative', zIndex : 2, display:'flex', justifyContent:'center' }}>
                            <Button
                                type="primary"
                                style={{
                                    background: 'linear-gradient(131.18deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4',
                                    borderColor: 'linear-gradient(131.18deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4',
                                    borderRadius: '45px',
                                    float: 'right',
                                    width: '219px',
                                    textAlign: 'center',
                                    fontWeight: '500',
                                    fontSize: '19px',
                                }}
                                size={'large'}
                                onClick={search}
                            >
                                {/* <FormattedMessage {...messages.search} /> */}
                                <ButtonText text={`${langdata.search ? langdata.search : 'Search' }`} />
                            </Button>
                        </Col>
                        {/* </Col> */}
                        <Col xxl={{ span: 24, offset: 0 }} xl={{ span: 24, offset: 0 }} md={{ span: 24 }}>
                            {window.innerWidth < 768 ? (
                                <div style={{ textAlign: 'center' }}>
                                    <img
                                        alt='No image'
                                        src={qR2}
                                        onClick={() => { window.open('https://apps.apple.com/us/app/id1512292509'); }}
                                        style={{ cursor: 'pointer', marginTop: '36px', width: '50%' }}
                                    />
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                    <div className="marquee-container" >
                        <div
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            ref={containerRef}
                            className={`marquee-content ${isHovered || playingIndex || playingIndex === 0 ? 'paused' : ''}`}
                        >
                            {promos.map((item, index) => (
                                <div
                                    key={index}
                                    className="video-wrapper"
                                    onClick={() => handleVideoClick(index, item)}
                                >
                                    {playingIndex === index ? (
                                        <div 
                                            className="video-container"
                                            data-type={item.socialmediapromotionstype}
                                        >
                                            <iframe
                                                ref={(el) => {
                                                    if (el) {
                                                        el.setAttribute('allowfullscreen', 'true');
                                                    }
                                                }}
                                                width="100%"
                                                height="100%"
                                                src={getEmbedUrl(item.socialmediapromotionstype, item.url)}
                                                frameBorder="0"
                                                allow="autoplay; encrypted-media; fullscreen"
                                                allowFullScreen
                                                title={`${item.socialmediapromotionstype}-video`}
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    backgroundColor: '#000',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className="thumbnail"
                                            style={{ backgroundImage: `url(${item.thumbnail ? item.thumbnail : noImage})` }}
                                        >
                                            <div style={{color:item.socialmediapromotionstype=='youtube' ? '#c90808' : '#962fbf', fontSize:'20px', marginLeft:'2%'}}>{item.socialmediapromotionstype=='youtube' ? <YoutubeOutlined/> : item.socialmediapromotionstype=='instagram' ? <InstagramOutlined />: null}</div>
                                            <div className="play-button"><PlayCircleOutlined /></div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <Responsive />
                </div>
            </div>
            
            <div>
                <Row type="flex" justify="center" align="bottom" 
                    // className="testimonial"
                    style={{background:'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%)'}}
                
                >
                    <Col span={24} style={{marginTop:'2%'}}>
                        <div style={{ fontSize: '34px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto' }}>
                            <Typography
                                style={{
                                    fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '24px' : '34px',
                                    // fontFamily: 'Roboto',
                                    // fontWeight : 'bold',
                                    color: '#ffffff',
                                    justifyContent:'center', display:'flex',
                                    textAlign:'justify'
                                }}
                            >{langdata.WhatOurUsersSay ? langdata.WhatOurUsersSay : 'What our users have to say...' }
                            </Typography>
                        </div>
                        <Col span={24}>
                            <Row style={{display:'flex', justifyContent:'center'}}>
                                <Col span={4}>&nbsp;</Col>
                                <Col span={16} style={{justifyContent:'center'}}>
                        
                                    <Carousel autoplay style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        {/* <Col span={6}>&nbsp;</Col> */}
                                        {/* <Col span={12}> */}
                                        <div style={{ textAlign: 'center' }}>
                                            <TestimonialRepeat byName="- Mrs. Sunitha Verma" testimonials="I can&apos;t believe how easy it was to consult a doctor on QuikDr. I am not technically savvy but QuikDr made it all easy to use" windowsize={parseInt(viewportWidth/100)} />
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <TestimonialRepeat byName="- Mrs. Annie Mary Alexander" testimonials="I meet my cardiologist on my lunch break while at work. Online visits have allowed greater flexibility with scheduling visits! I would recommend everyone to switch to online appointments through QuikDr" windowsize={parseInt(viewportWidth/100)} />
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <TestimonialRepeat byName="- Mr. Manoj Chandran" testimonials="After a recent accident, going into the hospital was difficult for me. QuikDr helped me to with my followup consultations. Thank you!" windowsize={parseInt(viewportWidth/100)} />
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <TestimonialRepeat byName="- Mr. Vinod Felix" testimonials="QuikDr&apos;s KIOSK app made my life easy by simplifying taking appointments. Now I don&apos;t have to stand in long queues to get an appointment" windowsize={parseInt(viewportWidth/100)} />
                                        </div>
                                        {/* </Col> */}
                                        {/* <Col span={6}>&nbsp;</Col> */}

                                    </Carousel>
                                </Col>
                                <Col span={4}>&nbsp;</Col>
                            </Row>

                        </Col>
                        <div style={{ fontSize: '18px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto' }}>
                            <Typography
                                style={{
                                    fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                    // fontFamily: 'Roboto',
                                    color: '#fff',
                                    justifyContent:'center', display:'flex',
                                    textAlign:'justify', marginLeft:'3%', marginRight:'3%'
                                }}
                            >{langdata.EmergencyMessage ? langdata.EmergencyMessage : 'Telemedicine is not to be used during an emergency. In an Emergency, the patient needs to be taken to the nearby Hospital, for getting immediate care.' }
                            </Typography>
                        </div>
                        <br></br>
                    </Col>
                </Row>
            </div>            

            {/* Instagram Modal */}
            <div className={`instagram-modal-overlay ${isModalVisible ? 'active' : ''}`} onClick={handleModalClose}>
                <div className="instagram-modal" onClick={e => e.stopPropagation()}>
                    <button className="instagram-modal-close" onClick={handleModalClose}>×</button>
                    <div className="instagram-modal-content">
                        <iframe
                            src={modalVideoUrl}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            title="instagram-video"
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Home;
